import AsymmetricEncryptionService from "../services/AsymmetricEncryptionService"

export default {
    methods: {
        AuthMixin() {
            return {
                extractPermissionsAndSetLoggedInUserFromAdminToken: function({ token, useStore: useStore = false }) {
                    let decodedData;
                    
                    // Try new asymmetric decryption first
                    try {
                        const decrypted = AsymmetricEncryptionService.decryptFromBackend(token);
                        decodedData = JSON.parse(decrypted);
                    } catch (error) {
                        // NO FALLBACK - new encryption must work to avoid exposing APP_KEY
                        console.error('Failed to decrypt admin token:', error);
                        throw error;
                    }
                    
                    this.extractPermissions(decodedData);
                    if (useStore) {
                        this.$store.commit('SET_LOGGED_IN_USER', decodedData)
                    } else {
                        localStorage.setItem('loggedInUser', JSON.stringify(decodedData))
                    }
                    const first_name = decodedData.name?.split(' ')[0] ?? '';
                    const last_name = decodedData.name?.split(' ')[1] ?? '';
                    this.$localEncrypt.saveData('appUserDetails', { ...decodedData, ...( this.company && { company: this.company }), first_name, last_name });
                }.bind(this)
            }
        }
    }
};